export default __webpack_public_path__ + "static/Products_Placeholder_4.0-18555b773e4b3ff2aa74cdd9c03c99bd.jpg";